<template>
<v-container fluid>    
    <v-card class="ma-2" flat>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="programLoading"></v-progress-linear>
        <program-member-data-component :uid="uid"></program-member-data-component>
    </v-card>
    <v-layout wrap="true">
        <v-flex>
            <program-member-form-component :id="id" :uid="uid" :allowToManage="false" ref="programMemberFormComponent" @toGetOverviewData="toGetOverviewData($event)"></program-member-form-component>
        </v-flex>
        <v-flex xs12>
            <program-member-result-component :programInfo="programInfo" v-if="!programLoading"></program-member-result-component>
        </v-flex>
        <v-flex xs12>
            <program-member-survey-component :programInfo="programInfo" v-if="!programLoading"></program-member-survey-component>
        </v-flex>
        <v-flex xs12>
            <program-member-result-assignment-component :programInfo="programInfo" v-if="!programLoading"></program-member-result-assignment-component>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getProgramInfoById from "../data/getProgramInfoById";
import ProgramMemberResultComponent from "../components/ProgramMemberResultComponent.vue";
import ProgramMemberSurveyComponent from "../components/ProgramMemberSurveyComponent.vue";
import ProgramMemberFormComponent from "../components/ProgramMemberFormComponent.vue";
import ProgramMemberDataComponent from "../components/ProgramMemberDataComponent.vue";
import ProgramMemberResultAssignmentComponent from "../components/ProgramMemberResultAssignmentComponent.vue";
export default {
    name: 'ProgramViewMemberResult',
    metaInfo: {
        title: 'Program View Member Result'
    },
    components: {
        ProgramMemberResultComponent,
        ProgramMemberSurveyComponent,
        ProgramMemberDataComponent,
        ProgramMemberFormComponent,
        ProgramMemberResultAssignmentComponent
    },
    data() {
        return {
            title: '',
            programLoading: true,
            loading: false,
            enableEndProgram: false,
            programInfo: {},
            userInfo: {
                name: ''
            }
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.programLoading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.id = this.$route.params.id;
        this.uid = this.$route.params.uid;
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "loggedInUserId",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin",
            "isAccessOrgAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isAccessCoachAdmin || this.isAccessOrgAdmin) {
                (async () => {
                    this.programLoading = true;
                    this.programInfo = await getProgramInfoById(this.id, this.uid, 1);
                    this.programLoading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        toGetOverviewData(){
            return;
        }
    },
};
</script>
